import { Injectable } from '@angular/core';
import { IS_NOT_EMPTY, IS_NOT_NULL_OR_UNDEFINED } from 'cargo-chief-commons';

import { Cargochief } from '@service/cargochief/cargochief.service';

import { CARGOCHIEF_KEYS, NOTIFICATIONS } from '@domain/constants/app-variables';

@Injectable({
	providedIn: 'root',
})
export class UserNotificationsService {
	constructor(private readonly cargochief: Cargochief) {}

	get NEW_BROKER_CONNECTED(): boolean {
		return this.parseNotificationValue(NOTIFICATIONS.NEW_BROKER_CONNECTED);
	}

	get BA_BID_SELECT(): boolean {
		return this.parseNotificationValue(NOTIFICATIONS.BA_BID_SELECT);
	}

	get BA_BROKER_BID_COUNTER(): boolean {
		return this.parseNotificationValue(NOTIFICATIONS.BA_BROKER_BID_COUNTER);
	}

	get BA_BID_INVITE(): boolean {
		return this.parseNotificationValue(NOTIFICATIONS.BA_BID_INVITE);
	}

	get BA_LOAD_OWNER_UPDATE(): boolean {
		return this.parseNotificationValue(NOTIFICATIONS.BA_LOAD_OWNER_UPDATE);
	}

	parseNotificationValue(settingName: string): boolean {
		const notificationSetting = this.getNotifications();
		if (Array.isArray(notificationSetting)) {
			const notification = notificationSetting.find((setting) => setting?.name === settingName);
			return notification?.value === 'BOTH' || notification?.value === 'DESKTOP';
		}
		return false;
	}

	getNotifications(): any[] | null {
		const notificationsString = this.cargochief.getItem(CARGOCHIEF_KEYS.NOTIFICATION_SETTINGS);
		if (IS_NOT_EMPTY(notificationsString)) {
			try {
				const parsed = JSON.parse(notificationsString as string);
				return Array.isArray(parsed) ? parsed : null;
			} catch {
				return null;
			}
		}
		return null;
	}
}
